(() => {
  const boot = () => {
    const root = document.querySelector('[data-vkd-root]');
    if (!root) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = root.querySelectorAll('[data-vkd-reveal]');
    if (reduced) {
      reveals.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    reveals.forEach(el => io.observe(el));

    const layers = [...root.querySelectorAll('[data-vkd-parallax]')];
    const heroImage = root.querySelector('.vkd-hero__image');
    let ticking = false;
    const move = () => {
      const vh = window.innerHeight;
      layers.forEach(el => {
        const rect = el.getBoundingClientRect();
        const strength = Number(el.dataset.vkdParallax || 10);
        const progress = ((rect.top + rect.height * .5) - vh * .5) / Math.max(vh, 1);
        const y = Math.max(-1, Math.min(1, progress)) * strength;
        el.style.transform = `translate3d(0, ${y}px, 0)`;
      });
      if (heroImage) {
        const heroProgress = Math.max(0, Math.min(1, window.scrollY / Math.max(window.innerHeight, 1)));
        heroImage.style.transform = `scale(${1.1 + heroProgress * .08}) translate3d(0, ${heroProgress * 32}px, 0)`;
      }
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(move);
        ticking = true;
      }
    };
    move();
    addEventListener('scroll', onScroll, { passive: true });

    if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
      root.querySelectorAll('[data-vkd-magnetic]').forEach(card => {
        card.addEventListener('pointermove', e => {
          const r = card.getBoundingClientRect();
          const x = ((e.clientX - r.left) / r.width - .5) * 4;
          const y = ((e.clientY - r.top) / r.height - .5) * -4;
          card.style.transform = `perspective(1200px) rotateX(${y}deg) rotateY(${x}deg)`;
        });
        card.addEventListener('pointerleave', () => { card.style.transform = ''; });
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();
})();
